export const en = {
  'nav.ofertas': 'Jobs',
  'nav.profesionales': 'Professionals',
  'nav.empresas': 'Companies',
  'content.hubTitle': 'News & agenda',
  'content.hubSubtitle': 'Industry news, courses and events. Everything you need to stay up to date, in one place.',
  'content.all': 'All', 'content.news': 'News', 'content.training': 'Courses', 'content.events': 'Events',
  'content.filter': 'Filter content', 'content.search': 'Search news, courses or events…', 'content.readOnly': 'Editorial selection',
  'content.viewAll': 'View news & agenda',

  'nav.actualidad': 'News',
  'nav.formacion': 'Training',
  'nav.eventos': 'Events',
  'nav.forum': 'Forum',
  'nav.biblioteca': 'Library',
  'nav.colaboracion': 'Collaboration',
  'nav.donaciones': 'Donations',
  'nav.mercado': 'Marketplace',
  'nav.login': 'Sign in',
  'nav.register': 'Create account',
  'nav.publish': 'Post a job',
  'nav.search': 'Search',

  'hero.title': 'The professional hub for performing arts crews',
  'hero.subtitle': 'Find jobs, professionals, companies and opportunities in live technical production.',
  'hero.searchPlaceholder': 'Lighting technician, GrandMA3, rigging...',
  'hero.locationPlaceholder': 'Barcelona',
  'hero.searchWhat': 'What are you looking for?',
  'hero.searchButton': 'Search',
  'hero.quick.jobs': 'Browse jobs',
  'hero.quick.pros': 'Find professionals',
  'hero.quick.companies': 'Explore companies',

  'section.categories': 'Technical specialties',
  'section.categories.sub': 'Find professionals and jobs by specialty',
  'section.latestJobs': 'Latest jobs',
  'section.latestJobs.sub': 'Recent opportunities across the technical sector',
  'section.viewAll': 'View all jobs',
  'section.pros': 'Find professionals',
  'section.pros.sub': 'Search technicians by specialty, experience, location, availability and technical skills.',
  'section.pros.cta': 'Find professionals',
  'section.companies': 'Companies in the industry',
  'section.companies.sub': 'Verified technical companies directory',
  'section.companies.cta': 'View companies',
  'section.news': 'Industry news',
  'section.news.sub': 'News, tech and trends from backstage',
  'section.news.cta': 'View news',
  'section.training': 'Training',
  'section.training.sub': 'Courses, certifications and workshops',
  'section.training.cta': 'View training',
  'section.events': 'Industry events',
  'section.events.sub': 'Trade fairs, conferences and professional gatherings',
  'section.events.cta': 'View events',
  'section.stats': 'The industry in numbers',
  'section.stats.sub': 'Aggregated data from the Stage Crew community',
  'section.stats.demoNote': 'Sample data · Will activate with real records',

  'cta.employer.title': 'Looking for technical crew?',
  'cta.employer.text': 'Post your job and find professionals in the field.',
  'cta.employer.button': 'Post a job',
  'cta.employer.note': 'Free to start',

  'badge.verified': 'Verified',
  'badge.professionalPublished': 'Posted by professional',
  'badge.substitution': 'Substitution',
  'badge.urgent': 'Urgent',
  'badge.available': 'Available',
  'badge.onTour': 'On tour',
  'badge.demo': 'DEMO',

  'jobtype.trabajo': 'Job',
  'jobtype.sustitucion': 'Substitution',
  'jobtype.refuerzo': 'Reinforcement',
  'jobtype.bolsa': 'Talent pool',
  'jobtype.urgente': 'Urgent',
  'jobtype.otro': 'Other',

  'application.sent': 'Application sent',
  'application.withdraw': 'Withdraw application',
  'application.withdrawing': 'Withdrawing…',
  'application.withdrawSuccess': 'Application withdrawn. You can apply again while the job remains open.',
  'application.withdrawError': 'Could not withdraw your application. Please try again.',
  'application.withdrawHint': 'Click again to withdraw your application. You can reapply while the job remains open.',
  'application.closedHint': 'This job is closed. Contact its author if you need to report a change.',

  'label.applicants': 'applicants',
  'label.deadline': 'Deadline',
  'label.publishedBy': 'Posted by',
  'label.location': 'Location',
  'label.schedule': 'Schedule',
  'label.compensation': 'Compensation',
  'label.skills': 'Technical skills',
  'label.experience': 'Experience',
  'label.availability': 'Availability',
  'label.specialties': 'Specialties',
  'label.activeJobs': 'active jobs',
  'label.rating': 'Rating',
  'label.readMore': 'Read more',
  'label.viewOffer': 'View job',
  'label.viewProfile': 'View profile',
  'label.viewCompany': 'View company',
  'label.viewDetails': 'View details',
  'label.date': 'Date',
  'label.category': 'Category',
  'label.source': 'Source',
  'label.modality': 'Format',
  'label.price': 'Price',
  'label.school': 'School',
  'label.sponsored': 'Sponsored',
  'label.timeSlots': 'Time slots',
  'label.totalHours': 'Total hours',
  'label.hoursShort': 'h',
  'label.phone': 'Phone',
  'label.certifications': 'Certifications',

  'gate.title': 'Members only area',
  'gate.subtitle': 'Join STAGE CREW and enjoy all the benefits of our community. Create your free profile and access all its features.',
  'gate.login': 'Sign in',
  'gate.register': 'Create free account',

  'profile.title': 'My professional profile',
  'profile.subtitle': 'Complete your card and decide which information is shown publicly. Hidden fields are never shared with other users.',
  'profile.section.public': 'Public information',
  'profile.section.contact': 'Contact',
  'profile.section.skills': 'Skills and certifications',
  'profile.section.privacy': 'Privacy · what to show',
  'profile.visibility.on': 'Public',
  'profile.visibility.off': 'Hidden',
  'profile.save': 'Save changes',
  'profile.saved': 'Changes saved',
  'profile.error': 'Could not save. Try again.',
  'profile.field.role': 'Role / specialty',
  'profile.field.category': 'Category',
  'profile.field.location': 'Location',
  'profile.field.experience': 'Experience',
  'profile.field.availability': 'Availability',
  'profile.field.bio': 'Professional bio',
  'profile.field.phone': 'Phone',
  'profile.field.email': 'Contact email',
  'profile.field.skills': 'Technical skills (comma-separated)',
  'profile.field.certifications': 'Certifications (comma-separated)',
  'profile.myLink': 'My profile',

  'footer.tagline': 'The professional community for the performing arts',
  'footer.ofertas': 'Jobs',
  'footer.profesionales': 'Professionals',
  'footer.empresas': 'Companies',
  'footer.comunidad': 'Community',
  'footer.stagecrew': 'Stage Crew',
  'footer.legal': 'Legal',
  'footer.allJobs': 'All jobs',
  'footer.searchPros': 'Find professionals',
  'footer.createProfile': 'Create profile',
  'footer.searchCompanies': 'Find companies',
  'footer.registerCompany': 'Register company',
  'footer.publishJob': 'Post a job',
  'footer.about': 'About Stage Crew',
  'footer.contact': 'Contact',
  'footer.collaborate': 'Collaborate',
  'footer.advertising': 'Advertising',
  'footer.terms': 'Terms of use',
  'footer.privacy': 'Privacy',
  'footer.cookies': 'Cookies',
  'footer.copyright': '© 2026 Stage Crew · All rights reserved',

  'auth.login.title': 'Welcome back',
  'auth.login.subtitle': 'Access your Stage Crew account',
  'auth.register.title': 'Join Stage Crew',
  'auth.register.subtitle': 'Create your professional account in under a minute',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.name': 'Full name',
  'auth.accountType': 'Account type',
  'auth.accountPro': 'Professional',
  'auth.accountCompany': 'Company',
  'auth.submit.login': 'Sign in',
  'auth.submit.register': 'Create account',
  'auth.noAccount': 'No account yet?',
  'auth.hasAccount': 'Already have an account?',
  'auth.demoNotice': 'Demo authentication — backend pending',

  'meta.filters': 'Filters',
  'meta.results': 'results',
  'meta.sortBy': 'Sort by',
  'meta.newest': 'Newest first',
  'meta.oldest': 'Oldest first',

  'empty.title': 'No results',
  'empty.subtitle': 'Try adjusting your search filters',
};
